import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import {goBack} from "../../fn/navigation";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Card from "@material-ui/core/Card/Card";
import CourseDetails from "../../components/Courses/CourseDetails";

const CoursesShow = ({course, backLink, houses}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={course.is_company ? course.company_name : course.first_name + ' ' + course.last_name}
            items={[
                {
                    icon: 'arrow_back_ios',
                    text: i18n.get('courses.back'),
                    href: backLink,
                    onClick: (event) => {
                        event.preventDefault();
                        goBack(backLink);
                    },
                    color: 'secondary',
                },
                {
                    icon: 'edit',
                    text: i18n.get('courses.edit'),
                    href: `/courses/${course.id}/edit`,
                }
            ]}
        />

        <Card>
            <CardContent>
                <CourseDetails course={course}/>
            </CardContent>
        </Card>
    </Layout>
);

export default CoursesShow;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/accounts/Show.jsx